<template>
  <div class="card">
  
    <div class="card-header">
      Custom Timeline Course Card
    </div>

    <div class="card-content">
      <div class="card-header-title">
            <span class="text-base white--text">Live-Teilnahme am Kurs möglich bei folgenden Terminen</span>
          </div>
      <b-field
        dense
        class="timeline-custom-dense timeline-custom-dots card-content"
      >
        <!-- Flight -->
        <b-timepicker
          small
          inline
          rounded
          :editable=false
          icon="clock"
          placeholder="Click to select..."
          :hour-format="hourFormat"
          v-model="time"
          color="error"
        >
          <div class="card" color="error">
            <div class="card-header-title">
              <span class="text-base white--text">Get on the course</span>
              <v-spacer></v-spacer>
              <small class="text-xs white--text">| Wednesday</small>
            </div>
            <div class="card-content pt-4">
              <p class="mb-1">
                <span>Charles de Gaulle Airport, Paris</span>
                <!-- <v-icon
                  size="20"
                  class="mx-2"
                >
                  {{ icons.mdiArrowRight }}
                </v-icon> -->
               
              </p>
              <div class="d-flex flex-column">
                    <p class="text--primary font-weight-semibold mb-0">Rebecca Godman</p>
                    <span>Javascript Developer</span>
                  </div>
              <span class="d-flex align-center">
                <!-- <v-icon
                  color="error"
                  class="me-1"
                >
                  {{ icons.mdiFilePdf }}
                </v-icon> -->
                <span class="text--primary font-weight-semibold text-sm">Kursplan.pdf</span>
              </span>
            </div>
          </div>
        </b-timepicker>

        <!-- Interview Schedule -->
        <b-timepicker
          small
          inline
          color="primary"
        >
          <div class="card" color="card primary">
            <div class="card-header-title">
              <span class="text-base white--text">Interview Schedule</span>
              <v-spacer></v-spacer>
              <small class="text-xs white--text text-no-wrap">April, 18</small>
            </div>
            <div class="card-content pt-4">
              <p class="mb-0">
                Berliner Flughafen BER, Berlin
              </p>

              <!-- Divider -->
              <v-divider class="my-4"></v-divider>

              <!-- Person -->
              <div class="d-flex justify-space-between align-center">
                <!-- Avatar & Personal Info -->
                <span class="d-flex align-bottom mt-2">
                  <v-avatar
                    size="40"
                    class="me-2"
                  >
                    <v-img src="@/assets/images/avatars/2.png"></v-img>
                  </v-avatar>
                  <div class="d-flex flex-column">
                    <p class="text--primary font-weight-semibold mb-0">Rebecca Godman</p>
                    <span>Javascript Developer</span>
                  </div>
                  <span class="d-flex align-center">
                <!-- <v-icon
                  color="error"
                  class="me-1"
                >
                  {{ icons.mdiFilePdf }}
                </v-icon> -->
                <span class="text--primary font-weight-semibold text-sm">Kursplan.pdf</span>
              </span>
                </span>

                <!-- Person Actions -->
                <div>
                  <v-icon class="me-2">
                    <!-- {{ icons.mdiMessageTextOutline }} -->
                  </v-icon>
                  <!-- <v-icon>{{ icons.mdiPhone }}</v-icon> -->
                </div>
              </div>
            </div>
          </div>
        </b-timepicker>

      </b-field>
    </div>
</div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
// import { mdiFilePdf, mdiArrowRight, mdiMessageTextOutline, mdiPhone } from '@mdi/js'

export default {
  setup() {

    return {
      hourFormat: undefined, // Browser locale
      time: new Date(),
      icons: {
        // mdiFilePdf,
        // mdiArrowRight,
        // mdiMessageTextOutline,
        // mdiPhone,
      },
    }
  },
}
</script>
